import { render, staticRenderFns } from "./ResetCode.vue?vue&type=template&id=a277e228&scoped=true&"
import script from "./ResetCode.vue?vue&type=script&lang=js&"
export * from "./ResetCode.vue?vue&type=script&lang=js&"
import style0 from "./ResetCode.vue?vue&type=style&index=0&id=a277e228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a277e228",
  null
  
)

export default component.exports